import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=667c0226&scoped=true&"
import script from "./Multiple.vue?vue&type=script&lang=js&"
export * from "./Multiple.vue?vue&type=script&lang=js&"
import style0 from "./Multiple.vue?vue&type=style&index=0&id=667c0226&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c0226",
  null
  
)

export default component.exports